// libraries.
import { Dropdown } from 'react-bootstrap';
import { robotoRegular } from '@habitech/shared';
import { useDispatch, useSelector } from 'react-redux';

// slices.
import {
  ModePolygon,
  getModePolygon,
  setModePolygon,
} from '@domains/save-polygons/store/slices/modePolygon.slice';
import { setDefaultState } from '@domains/polygon-tool/store/slices/polygon-slice';
import { polygonRefs } from '@domains/polygon-tool/utils';
import { getMedianZoneCode } from '@domains/median-zones/store/slices/medianZones.slice';

import { getIsRoleIsPolygonCreator } from '@domains/user/store/slices/user-slice/user-slice';

const modeOptions = [
  { mode: ModePolygon.CREATE, label: 'Crear Polígono' },
  { mode: ModePolygon.EDIT, label: 'Editar Polígono' },
  { mode: ModePolygon.VIEW, label: 'Ver Polígono' },
];

export const DropDownModePolygon = () => {
  const dispatch = useDispatch();
  const modePolygon = useSelector(getModePolygon);
  const medianZoneCode = useSelector(getMedianZoneCode);
  const isPolygonCreator = useSelector(getIsRoleIsPolygonCreator);

  const handleSelect = (mode: ModePolygon) => {
    dispatch(setModePolygon(mode));
    polygonRefs.forEach(polygon => {
      if (polygon) {
        polygon.setMap(null);
      }
    });
    polygonRefs.length = 0;
    dispatch(setDefaultState());
  };

  // Gate modes by role (D-13): Viewer can only navigate via VIEW; CREATE/EDIT
  // are Creator-only. The medianZoneCode guard is kept as an additional
  // precondition for CREATE/EDIT (they only make sense once a zone is selected).
  const filteModeOptions =
    !medianZoneCode || !isPolygonCreator
      ? modeOptions.filter(option => option.mode === ModePolygon.VIEW)
      : modeOptions;

  return (
    <Dropdown>
      <Dropdown.Toggle className="btn-habi-white" id="dropdown-basic">
        {filteModeOptions.find(option => option.mode === modePolygon)?.label ||
          'Modo'}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {filteModeOptions.map(option => (
          <Dropdown.Item
            key={option.mode}
            onClick={() => handleSelect(option.mode)}
            style={{
              fontSize: '14px',
              fontFamily: robotoRegular,
            }}
          >
            {option.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};
